import GraphemeSplitter from "grapheme-splitter";
import processHtml from './processHtml'
import settings from "./settings"
import addActionsToTypewriter from "./actions"




const addEvents = ({typewriter, finishedCallback, chunk, inputData, print}) => {

    const arrayOfActions = processHtml({
        html: chunk.html,
        isResponse: false,
        inputData
    })

    addActionsToTypewriter({
        typewriter,
        finishedCallback,
        arrayOfActions,
        isEndOfTypewriterBlock: chunk.endTypewriterBlock,
        isResponse: false,
        print,
        chunk
    })
    if (typewriter) {
        typewriter.start()
    }
}

const typeButtonText = ({typewriter, button, print, chunk, finishedCallback}) => {

    const buttonText = button.response ? button.response : button.text

    const newArrayOfActions = [[`<mark class="terminal-response">${buttonText}</mark>`]]

    // const arrayOfActions = processHtml({
    //     html: `<p>${buttonText}</p>`,
    //     isResponse: true
    // })
    //
    // //Wrap all actions in markup
    // const newArrayOfActions = arrayOfActions.map(actions => {
    //     const newActions = actions.map(str => {
    //         return `<mark class="terminal-response">${str}</mark>`
    //     })
    //     return newActions
    // })

    addActionsToTypewriter({
        typewriter,
        arrayOfActions: newArrayOfActions,
        isEndOfTypewriterBlock: false,
        isResponse: true,
        finishedCallback,
        chunk,
        print,
        button
    })

    if (typewriter) {
        typewriter.start()
    }

}



const typewriterConfig = {
    options: {
        loop: false,
        delay: settings.changeDelay.default,
        stringSplitter: string => {
            const splitter = new GraphemeSplitter();
            return splitter.splitGraphemes(string);
        }
    },
    addEvents: addEvents,
    typeButtonText: typeButtonText
}

export default typewriterConfig;
